
export enum AppType {
    bluehosting = 'BH',
    tuu = 'TUU',
    chilefirmas = 'CF'
}